import React, { MouseEventHandler } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { BaseElementProps } from "../types/BaseElementProps";
import classNames from "classnames";

export interface Props {
  icon: IconProp;
  size?: SizeProp;
  onClick?: MouseEventHandler<any> | undefined;
  color?: string;
  hoverPrimaryColor?: boolean;
  id?: string;
  title?: string;
  role?: string;
}

export function FakeAntdIcon({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { children?: React.ReactNode }) {
  return (
    <span
      className={classNames(
        "inline-block font-normal leading-[0] text-center normal-case align-[-0.125em] antialiased [&_.fa-fls]:scale-[0.8]",
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export default function (props: Props & BaseElementProps) {
  return (
    <FakeAntdIcon
      className={classNames(props.className, "anticon", { "hover-main-color": props.hoverPrimaryColor })}
      id={props.id}
      role={props.role}
      style={{ color: props.color }}
      title={props.title}
      onClick={props.onClick}
    >
      <FontAwesomeIcon icon={props.icon} size={props.size} style={props.style as any} />
    </FakeAntdIcon>
  );
}
